import { LEGACY_SERVICE_CONTENT_ID_MAP } from './legacyContentIdMap.generated.js'

/**
 * @description 取得需要规范化为生产内容 ID 的旧服务内容 ID。
 * @param {string|number|null|undefined} value - 路由或历史链接中的内容 ID。
 * @returns {string|null} 命中且不同于原 ID 的生产内容 ID；未命中或相同 ID 返回 null。
 */
export const getLegacyServiceContentRedirectId = (value) => {
  const id = String(value ?? '').trim()
  const canonicalId = LEGACY_SERVICE_CONTENT_ID_MAP[id]
  return canonicalId && canonicalId !== id ? canonicalId : null
}

/**
 * @description 将迁移前的服务内容 ID 转换为当前内容中心 ID。
 * @param {string|number|null|undefined} value - 路由或历史链接中的内容 ID。
 * @returns {string} 当前可用于内容接口的 ID；非旧格式保持原值。
 * @reason 精确映射优先，避免按长度补前缀误改迁移后保持不变的内容 ID；未登记历史链接保留原兼容逻辑。
 */
export const resolveLegacyServiceContentId = (value) => {
  const id = String(value ?? '').trim()
  const canonicalId = LEGACY_SERVICE_CONTENT_ID_MAP[id]
  if (canonicalId) return canonicalId
  if (!/^\d+$/.test(id)) return id
  if (id.length === 3) return `100${id}`
  if (id.length === 4) return `10${id}`
  return id
}
